import styled from 'styled-components';

export const ThreadCardStyled = styled.div`
  padding: 20px;
  border-radius: 12px;
  background: #161616;
  border: 1px solid #262626;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;

  &:hover {
    border-color: #333;
    background: #1c1c1c;
  }

  .row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .accent {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    cursor: pointer;
    background: rgba(3, 160, 141, 0.12);
    color: var(--primary);
  }

  .body {
    flex: 1;
    min-width: 0;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  .title {
    display: block;
    margin: 0 0 4px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    color: var(--white);
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .desc {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #a0a0a0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .menu {
    position: relative;
    flex-shrink: 0;
  }

  .menu-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #808080;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      color: var(--white);
    }
  }

  .menu-panel {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    z-index: 20;
    min-width: 168px;
    padding: 6px;
    border-radius: 10px;
    background: #161616;
    border: 1px solid #2a2a2a;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  }

  .menu-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #a0a0a0;
    font-size: 13px;
    text-align: left;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      color: var(--white);
    }

    &.danger {
      color: #ef4444;

      &:hover {
        background: rgba(239, 68, 68, 0.1);
        color: #ef4444;
      }
    }
  }

  .date {
    display: block;
    margin-top: 12px;
    padding-left: 56px;
    font-size: 12px;
    line-height: 16px;
    color: #606060;
  }
`;

/** Kept for leftover imports */
export const MenuBtn = styled.button``;
export const ReponseMenu = styled.div``;
export const StyleItem = styled.div``;
